

/// <reference path="DBMappingEntity.ts" />

// Generated class DBMappingEntityCeco_ManagedObject

class DBMappingEntityCeco_ManagedObject extends DBMappingEntity
{
}
